import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";

export default function GenerateEmployeePopUp({
  setEmployeePopUp,
  employeePopUp,
  employeeProp,
  setTrigger,
  trigger,
}) {
  const token = localStorage.getItem("nodeToken");
  console.log("employeeProp to be seen in console",employeeProp)
  const APICALL = async () => {
    const reqObj = {
      status: 4,
      employee_id: employeeProp.employee_id,
      new_visa_segment : employeeProp.new_visa_segment,
      generateStatus : employeeProp.NewEmployeeId != null ? false : true
    };
    const endpoint =
      employeeProp.sub_segment === "Changing"
        ? `/nakal-kafala/UpdateStatus`
        : `/nakal-kafala/updateNakalaStatus`;
    try {
      const response = await nodeinstance.put(`${endpoint}`, reqObj, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        setTrigger(!trigger);
        setEmployeePopUp(false);
      }
      console.log("response", response);
    } catch (error) {
      console.log("error to be seen here", error);
    }
  };
  return (
    <>
      <div className="fixed z-50 inset-0 bg-black/50 flex justify-center items-center">
        <div className="max-w-xl w-full max-h-[35rem] min-h-[15rem] overflow-scroll rounded-md bg-white/95 flex flex-col py-4 px-8 relative">
          <div className="flex justify-between items-center w-full mt-1 mb-3">
            <h1 className="text-xl font-semibold">
              {" "}
              {employeeProp.sub_segment != "Changing"
                ? "Complete Nakal Kafala"
                : "Generate Employee ID and process completed"}
            </h1>
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setEmployeePopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="w-full">
            <div className="w-full flex flex-col gap-3 my-3 p-5 text-center">
              <div
                className="flex gap-3 w-full justify-center"
                style={{ margin: 2 }}
              >
                <button
                  //   type="submit"
                  className="p-3 bg-green-500 text-white rounded-md w-full max-w-48  my-4 flex  justify-center items-center text-sm"
                  onClick={() => {
                    APICALL();
                  }}
                >
                  <p>
                    {employeeProp.sub_segment != "Changing"
                      ? "proceed"
                      : "Generate employee ID & Proceed"}
                  </p>
                  {/* {loading ? <CgSpinner className="animate-spin" /> : ""} */}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
